module.exports = __webpack_public_path__ + "img/yellowfewerzone.c6587a12.png";